import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { TryCatchStmt } from '@angular/compiler';
import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';

import { UtilesService } from './utiles.service';

import { ReporteError } from '../Models/ReporteError';
@Injectable()
export class ReporteErrorService {

  constructor(
    private _http: Http,
    private _utiles: UtilesService) { }


  /**
   * Obtiene una lista de errores 
   * @param compania Codigo de la compañia
   * @param fecha Fecha a la cual se desea buscar
   * @param referencia1 
   * @param referencia2 
   * @param referencia3 
   */
  ObtenerReportePuntosVisita(compania: string, fecha: Date, referencia1: string, referencia2: string, referencia3: string): Observable<ReporteError[]> {

    try {

      let url = this._utiles.getURL("ReporteErrores/reporteError/" + compania + '/' + fecha + '/' + referencia1 + '/' + referencia2 + '/' + referencia3);


      return this._http.get(url).map((response: Response) => {
        return <ReporteError[]>response.json();
      });



    } catch (error) {

      console.log(error);
    }

  }


}
